// import { mapGetters, mapActions } from 'vuex'
import ProviderService from '../../../services/booking'
import {parseDateTime, formatDate} from '../../../lib/dates'
import {alert, getQS} from '../../../lib/utils'
import {createNamespacedHelpers} from 'vuex'
import {productType, resetHold} from '../../../vuexstore/modules/tickets'
import {default as store, absoluteNamespace} from '../../../vuexstore/modules/tickets'
const {mapGetters, mapActions} = createNamespacedHelpers(absoluteNamespace)

const EventBus = window.VueEventBus
const qs = getQS() || {}
const noHold = !!qs.nohold

/**
 *
 * @param options{storePath: '', get: '', set: '', prefix: '', suffix: ''}
 * @returns {*}
 */
export const mapState = (options) => {
  const {storePath, prefix = '', suffix = '', depth = null} = options
  const states =  _.reduce(storePath, (fns, item, key) => {
    const fnKey = prefix + key + suffix
    if (depth) {
      key = depth + '.' + key
    }
    fns[fnKey] = {
      get() {
        return this.input(key)
      },
      set(value) {
        this.setInput({[key]: value})
      }
    }
    return fns
  }, {})
  return states
}

export default {
  data() {
    return {
      chosenDate: '', // as wrapper for selectedDate
    }
  },
  methods: {
    async askAndRemoveSelectedTimeSlot(reason, callback, denied, callbefore) {
      if (!_.isEmpty(this.selectedTimeslots)) {
        const options = {
          message: `Your selected time options will be removed due to ${reason}.`
        }
        options.confirmed = async () => {
          if (callbefore) {
            await callbefore()
          }
          this.cleanTimeslots()
          this.clearLocalCart()
          if (callback) {
            await callback()
          }
        }
        if (denied) {
          options.denied = denied
        }

        this.confirm(options)

      } else {
        if (callback) {
          callback()
        }
      }
    },
    isAnyProcessing() {
      return _.some(this.selectedSlots || {}, ({processing = false}) => processing)
    },
    startHoldAnimation (time) {
      this.setTimeslotData({time: time, key: 'processing', value: true})
      this.setRetrievedTimeslotData({time: time, key: 'processing', value: true})
    },

    endHoldAnimation (time) {
      this.setTimeslotData({time: time, key: 'processing', value: false})
      this.setRetrievedTimeslotData({time: time, key: 'processing', value: false})
    },

    async holdSlot(slot, quantity) {
      const {hold, time} = slot
      this.startHoldAnimation(time)

      let newHold
      try {
        if (!noHold) {
          newHold = await ProviderService.hold(hold, quantity)
        }
      } catch (e) {
        alert('Unable to set temporary hold on your selected slot. Please try again!', {classes: 'text-danger'})
      } finally {
        this.endHoldAnimation(time)
      }
      if (newHold) {
        return _.merge({}, hold, newHold || {})
      }
      return null
    },
    async unholdSlot(slot, noAnimation) {
      const hold = slot.hold || {}
      const time = slot.time
      if (!hold.id) {
        return
      }
      if (!noAnimation) {
        this.startHoldAnimation(time)
      }

      const newHold = resetHold(hold)
      const resetData = [
        {time, key: 'participants', value: 0},
        {time, key: 'selected', value: false},
        {time, key: 'hold', value: newHold}
      ]
      resetData.forEach(item => {
        this.setTimeslotData(item)
      })
      this.setRetrievedTimeslotDataItems(resetData)
      if (!noHold) {
        try {
          ProviderService.unhold(hold)
        } catch (e) {
          //
        }
      }
      if (!noAnimation) {
        this.endHoldAnimation(time)
      }
    },
    async unholdSlots(slots) {
      _.forOwn(slots, async (slot) => {
        await this.unholdSlot(slot)
      })
    },
    async unholdFirstSelectedSlot() {
      const slots = _.values(this.selectedSlots)
      const slot = _.minBy(slots, ({selected}) => 1 * selected)
      debugLog({unholdFirstSelectedSlot: slots, slot})
      if (slot && slot.selected) {
        this.setTimeslotData({time: slot.time, key: 'participants', value: 0})
        const selectedSlot = _.cloneDeep(slot)
        this.unholdSlot(selectedSlot)
        selectedSlot.selected = false
        this.updateTimeslotSelection(selectedSlot)
      }
    },
    getEarliestSlotTime(item, slots) {
      slots = slots || _.values(_.get(item, 'payload.options.form.selectedSlots', {}))
      if (!_.isEmpty(slots)) {
        const slot = _.minBy(slots, o => {
          return parseDateTime(o.datetime).valueOf()
        })
        if (slot) {
          return parseDateTime(slot.datetime).toSeconds()
        }
      }
      return null
    },
    ...mapActions(Object.keys(store.actions))
  },
  computed: {
    reservationType: () => productType,
    ...mapGetters(Object.keys(store.getters)),
    ...mapState({storePath: store.state.form}),
    ...mapState({storePath: store.state.form.contact, depth: 'contact'}),

    availableDates() {
      const dates = _.values(_.cloneDeep(this.bookableDates)).sort()
      return _.reduce(dates, (dates, date) => {
        dates[date] = formatDate(date, 'MMMM, d')
        return dates
      }, {})
    },
    quantityLimit() {
      return this.selectedProductMaxQuantity
    }
  },
}
